"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _AllocateCredits = _interopRequireDefault(require("../components/AllocateCredits"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function AllocateCreditsContainer(_ref) {
  var organisationId = _ref.organisationId,
      visible = _ref.visible,
      onClose = _ref.onClose,
      creditBalance = _ref.creditBalance,
      creditType = _ref.creditType,
      onCreditTypeChange = _ref.onCreditTypeChange,
      teams = _ref.teams,
      onUpdateOrgBalance = _ref.onUpdateOrgBalance,
      onUpdateTeams = _ref.onUpdateTeams,
      onCreditsUpdated = _ref.onCreditsUpdated;
  return _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      getOrgRecurringBalance: (0, _api.getOrgRecurringBalanceQuery)(organisationId)
    }
  }, function (requests) {
    return _react.default.createElement(_AllocateCredits.default, _extends({
      organisationId: organisationId,
      creditBalance: creditBalance,
      visible: visible,
      creditType: creditType,
      onClose: onClose,
      teams: teams,
      onCreditTypeChange: onCreditTypeChange,
      onUpdateOrgBalance: onUpdateOrgBalance,
      onUpdateTeams: onUpdateTeams,
      onCreditsUpdated: onCreditsUpdated
    }, requests));
  });
}

var _default = AllocateCreditsContainer;
exports.default = _default;